{
	"title": "Αποτύπωμα",
	"backTitle": "Πίσω",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Χαϊδελβέργη",
			"country": "Γερμανία"
		},
		"contact": {
			"telephone": "Τηλέφωνο: +49 6221 481-0",
			"telefax": "Τηλέφαξ: +49 6221 481-13553",
			"email": "Email: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Έδρα της εταιρείας: Χαϊδελβέργη",
			"commercialRegister": "Εμπορικό μητρώο: Mannheim, HRB 741878",
			"managingDirectors": "Διευθύνοντες Σύμβουλοι:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
